// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { EnvironmentConfig } from '../app/model/environment';

// NOTE: Please do not change environment settings
export const environment: EnvironmentConfig = {
  production: false,
  preProduction: false,
  staging: false,
  testing: false,

  cdnRoot: 'https://staging-static.vrm-mentor.com/assets/',
  languageAssetCdnRoot: '../assets/',
  vrmFormsLanguageAssetCdnRoot: '../assets/vrm-forms-language-files/',
  oneTrustCookieDataValue: 'aca3ac6e-7f47-40eb-a3eb-2a03f118a748-test',

  api: {
   // uri: 'http://localhost:3000/',
    uri: 'https://mis-api-dev.vrm-mentor.com/',
    env: 'dev',
    publishableKey: 'pk_test_WMqzTWoKVwz3Taqzl8422v7m',
    returnUrlBilling: 'https://staging-mis.vrm-mentor.com/#/billing',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
